import React from "react";
import SetZoom from "./SetZoom.jsx";
import CSButton from "./buttons/CSButton.jsx";
import { MdZoomInMap, MdZoomOutMap } from "react-icons/md";
import { AiOutlineExpand } from "react-icons/ai";
import { FaCompress } from "react-icons/fa";
import { FaMaximize } from "react-icons/fa6";

const ZoomControls = ({
  onZoomIn,
  onZoomOut,
  onReset,
  onFit,
  setScale,
  currentScale,
  minScale,
  maxScale,
  // labels supplied by wrapper/app
  messages = {},
}) => {
  const {
    zoomIn = "Zoom In",
    zoomOut = "Zoom Out",
    zoomToFit = "Zoom to Fit",
    reset = "Reset Zoom",
    min = "Zoom Min",
    max = "Zoom Max",
  } = messages;

  return (
    <div className="button-container small-buttons">
      <SetZoom
        label={currentScale}
        setScale={setScale}
        minScale={minScale}
        maxScale={maxScale}
        messages={{ reset, min, max }}
      />
      <CSButton onClick={onZoomIn} title={zoomIn}>
        <MdZoomInMap className="cs-medium-icon" />
      </CSButton>
      <CSButton onClick={onZoomOut} title={zoomOut}>
        <MdZoomOutMap className="cs-medium-icon" />
      </CSButton>
      <CSButton onClick={onFit} title={zoomToFit}>
        <AiOutlineExpand className="cs-medium-icon" />
      </CSButton>
      <CSButton onClick={onReset} title={reset}>
        <FaCompress className="cs-medium-icon" />
      </CSButton>
      <CSButton onClick={() => setScale(maxScale)} title={max}>
        <FaMaximize className="cs-medium-icon" />
      </CSButton>
    </div>
  );
};

export default ZoomControls;
